import { createFileRoute } from "@tanstack/react-router"

import { UnpublishedWorkPanel } from "@/pages/UnpublishedWorkPanel"

export const Route = createFileRoute("/monitoring/unpublished")({
  component: UnpublishedWorkPanel,
})
